// extracted by mini-css-extract-plugin
export var label = "_bh-1";
export var reminder = "_bh-0";